import styled from "styled-components";
import { size } from "styled-theme";

const Wrapper = styled.div`
  .verifyBankDetails-Container {
    display: flex;
    border-radius: 5px;
    font-size: ${size("p2")};
    justify-content: center;
    padding: 0 15px;
    position: relative;
    flex-direction: column;
    align-items: center;
  }

  .label {
    margin-right: 3px;
    font-weight: 700;
  }
  .center-align {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction:column;
  }

  .next-buton-container{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;

export default Wrapper;
